import React from 'react';
import './TypeBtn.css'

const TypeBtn = (props) => {
    return ( 
        <button className={props.TypeBtnStyle}>
            <img src={props.TypeBtnImg} alt="" />
            <p className='TypeBtnText'>{props.TypeBtnText}</p>
        </button>
     );
}
 
export default TypeBtn;